document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.read-more-collection').forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        
        var showType = this.getAttribute('data-show');
        var truncated = document.getElementById('truncated-' + showType);
        var fullDescription = document.getElementById('fullDescription-' + showType);
        
        truncated.style.display = 'none';
        fullDescription.style.display = 'block';
      });
    });
  
    document.querySelectorAll('.read-less-collection').forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        
        var showType = this.getAttribute('data-show');
        var truncated = document.getElementById('truncated-' + showType);
        var fullDescription = document.getElementById('fullDescription-' + showType);
        
        truncated.style.display = 'block';
        fullDescription.style.display = 'none';
      });
    });
  });
  